import DOMPurify from "dompurify";

export const domSanitization = (str: string): string => {
  try {
    return DOMPurify.sanitize(str);
  } catch {
    return "";
  }
};
